import { useMutation, UseMutationOptions } from "@connectrpc/connect-query";

import { getPresignedDownloadUri } from "@gx/ts-contracts/services/source/api/source-SourceService_connectquery";

export const useGetPresignedDownloadUriMutation = (
  options?: UseMutationOptions<
    typeof getPresignedDownloadUri.input,
    typeof getPresignedDownloadUri.output
  >,
) => {
  return useMutation<typeof getPresignedDownloadUri.input, typeof getPresignedDownloadUri.output>(
    getPresignedDownloadUri,
    options,
  );
};
